export { default } from './pipes.component';
